<div class="tab-container">
  <div class="tab-container__column summary">
    <fz-score-summary
      [eventCode]="eventCode"
      [viewEntryFee]="true"
      [showSummary]="user?.user !== null && user?.user !== undefined"
      [prizeImage]="prizeImage"
      [isLEP]="details()?.lifeExperience"
      [seats]="eventScheduleDetails?.totalEntryCount"
      [prizeValue]="eventScheduleDetails?.firstPrize?.prizeValue"
      [entryAmount]="eventScheduleDetails?.entryAmount"
      [bestScore]="bestScores"
      [eventScheduleDetails]="eventScheduleDetails"
      [metadata]="details()?.metadata"
    ></fz-score-summary>
  </div>
  <div class="tab-container__column bottom-spacer">
    <mat-card
      appearance="outlined"
      class="section passes-list-section mb--2"
      #passesSection
      *ngIf="tournamentPasses && tournamentPasses.length > 0"
    >
      <div class="section__root passes-list-section__root">
        @if (
          tournamentPassesLoaded &&
          tournamentPasses &&
          tournamentPasses.length > 0
        ) {
          <div class="passes-list-section__header">
            <h2 class="section__root__title section__root__title__mobile">
              Better deal? Buy a pass
            </h2>
            <h2 class="section__root__title section__root__title__desktop">
              Better deal? Save when buying a pass
            </h2>
            <p class="passes-list-section__header__subtitle">
              Entry fee for this tournament:
              <b>
                <fz-currency [value]="eventScheduleDetails?.entryAmount">
                </fz-currency>
              </b>
            </p>
          </div>
        }
        <div class="passes-list-section__content">
          <ng-container>
            <fz-pass-card-list
              [loaded]="tournamentPassesLoaded"
              [error]="false"
              [passes]="tournamentPasses"
              [tournamentEntryFee]="eventScheduleDetails?.entryAmount || 0"
              (passPressed)="clickBuyPassButton($event)"
              (sharePressed)="onSharePromoCode($event)"
            ></fz-pass-card-list>
          </ng-container>
        </div>
        @if (tournamentPasses && tournamentPasses.length > 0) {
          <div class="passes-list-section__footer">
            <div class="passes-list-section__footer__icon">
              <mat-icon>information</mat-icon>
            </div>
            <p class="passes-list-section__footer__text not-padding">
              This pass only works to play in this specific tournament, if you
              want to buy a pass for another tournament you can go to their
              respective Overview Page.
            </p>
          </div>
        }
      </div>
    </mat-card>

    <div class="tab-container__overview">
      @if (gameInfo) {
        <fz-ui-game-details
          [game]="getGameInfo()"
          [tournament]="{
            name: details()?.name || '',
            overview: details()?.metadata?.tournamentOverview ?? ''
          }"
          [startDate]="startDate()"
          [endDate]="endDate()"
        >
        </fz-ui-game-details>
      }

      <ng-container *ngTemplateOutlet="playControls"></ng-container>
    </div>
  </div>
</div>
